// extracted by mini-css-extract-plugin
export default {"container":"errors_container__eNjZR","icon":"errors_icon__XQzaC","title":"errors_title__FwfUX","subtitle":"errors_subtitle__WPceL","buttonContainer":"errors_buttonContainer__dZg9i"};